import { ComposeViewState } from 'owa-mail-compose-store';
import { logUsage } from 'owa-analytics';

export function logAttachmentDatapoints(viewState: ComposeViewState) {
    // attachmentWell and allAttachments are not typecast to avoid uneccesary imports into this package
    const attachmentWell = viewState.attachmentWell;
    if (attachmentWell) {
        const allAttachments: any[] = attachmentWell.docViewAttachments.concat(
            attachmentWell.imageViewAttachments
        );

        // Cosmos only logs datapoints if each custom data field has at most 24 unique values.
        // We expect more than 23 attachments/links in body to be a rare situation, so we round down to 23
        // in this case to preserve the rest of the data.
        const classicAttachmentCount = Math.min(
            allAttachments.filter(attachment => !attachment.isCloudy).length,
            23
        );
        const cloudyAttachmentCount = Math.min(
            allAttachments.filter(attachment => attachment.isCloudy).length,
            23
        );

        const linkInBodyCount = Math.min(attachmentWell.sharingLinkIds.length, 23);
        logUsage('AttachmentCountsOnMessageSent', [
            classicAttachmentCount,
            linkInBodyCount,
            cloudyAttachmentCount,
        ]);
    }
}
